<template>
  <section class="profile">
    <SidebarAccount />
    <div class="profile__data">
      <h2>Editar cadastro</h2>

      <form v-for="(info, i) in infos" :key="i">
        <div id="fisica" v-if="info.tpPessoa == 'F'">
          <div class="form-groups">
            <div class="label">
              <label for="">Nome completo: </label>
            </div>
            <div class="input">
              <input type="text" class="large" :value="info.nmcliente_razao" />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">E-mail: </label>
            </div>
            <div class="input">
              <input type="text" class="large" :value="info.email" disabled />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">CPF: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.cpfcnpj"
                disabled
              />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Gênero: </label>
            </div>

            <div class="radios">
              <input
                type="radio"
                name="genero"
                id="masculino"
                value="masculino"
                :checked="masculino"
              />
              <span>Masculino</span>
              <input
                type="radio"
                name="genero"
                id="feminino"
                value="feminino"
                :checked="feminino"
              />
              <span>Feminino</span>
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Data de nascimento: </label>
            </div>
            <div class="input">
              <input type="date" :value="dataNascimento" class="medium" />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Celular Principal: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.telefone[0].DDD + info.telefone[0].NRTelefone"
              />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Celular Secundário: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.telefone[1].DDD + info.telefone[1].NRTelefone"
              />
            </div>
          </div>
          <div class="form-groups">
            <button>Salvar alterações</button>
          </div>
        </div>
      </form>

      <form v-for="(info, i) in infos" :key="i">
        <div id="juridica" v-if="info.tpPessoa == 'J'">
          <div class="form-groups">
            <div class="label">
              <label for="">Razão Social: </label>
            </div>
            <div class="input">
              <input type="text" class="large" :value="info.nmcliente_razao" />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Nome Fantasia: </label>
            </div>
            <div class="input">
              <input type="text" class="large" :value="info.nmfantazia" />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">E-mail: </label>
            </div>
            <div class="input">
              <input type="text" class="large" :value="info.email" disabled />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">CNPJ: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.cpfcnpj"
                disabled
              />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Inscrição Estadual: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.inscricao"
                placeholder="Preencha apenas se houver IE"
              />
            </div>
          </div>
          <div class="form-groups">
            <div class="label">
              <label for="">Telefone Corporativo: </label>
            </div>
            <div class="input">
              <input
                type="text"
                class="medium"
                :value="info.telefone[1].DDD + info.telefone[1].NRTelefone"
              />
            </div>
          </div>
          <div class="form-groups">
            <button>Salvar alterações</button>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import SidebarAccount from "../SidebarAccount";

export default {
  data() {
    return {
      token: null,
      cpfcnpj: null,
      infos: [],
      masculino: false,
      feminino: false,
      dataNascimento: null,
    };
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        this.token = dados.token;
        this.cpfcnpj = dados.cpfCnj;

        const response = await axios.get(
          `https://www.leverosintegra.com.br/Map/api/Client/${this.cpfcnpj}?token=${this.token}`
        );

        this.infos = response.data;

        this.dataNascimento = response.data.Dados.dtNascimentoFundacao.slice(
          0,
          10
        );

        if (response.data.Dados.sexo == "M") {
          this.masculino = true;
        } else if (response.data.Dados.sexo == "F") {
          this.feminino == true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    SidebarAccount,
  },

  beforeMount() {
    this.getDados();
  },
};
</script>


<style lang="scss" scoped>
.profile {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 60px;

  @media (min-width: 441px) and (max-width: 768px) {
    max-width: 90%;
    flex-direction: row;
  }

  @media (min-width: 769px) {
    max-width: 85%;
    flex-direction: row;
  }

  @media (min-width: 1920px) {
    max-width: 65%;
    flex-direction: row;
  }

  &__data {
    width: 100%;
    padding: 30px 20px 0;

    @media (min-width: 441px) and (max-width: 768px) {
      width: 60%;
      padding: 0;
    }

    @media (min-width: 769px) {
      width: 80%;
      padding: 0;
    }

    h2 {
      color: var(--customGray-500);
      padding-bottom: 40px;
      font-size: 1.5rem;

    }

    label {
      color: var(--customGray-500);
      padding-bottom: 10px;
    }

    span {
      color: var(--customGray-500);
      margin: 0 20px 0 5px;
    }

    input {
      border: 1px solid var(--customGray-200);
      padding: 7px;
      border-radius: 5px;
      color: var(--customGray-800);
      font-size: 0.95rem;
      outline: none;
    }

    input[type="text"]:disabled {
      background: var(--customGray-100);
    }
  }
}

.form-groups {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 441px) {
    align-items: center;
    flex-direction: row;
  }

  .large {
    width: 100%;

    @media (min-width: 441px) {
      width: 70%;
    }
  }

  .medium {
    width: 70%;

    @media (min-width: 441px) {
      width: 30%;
    }
  }

  button {
    background: var(--standardGreen);
    color: var(--customWhite);
    padding: 10px;
    border-radius: 5px;
    margin-top: 30px;
  }

  .radios {
    display: flex;
  }

  .label {
    width: 100%;
    padding: 10px 0;

    @media (min-width: 441px) {
      width: 20%;
      padding: 0;
    }
  }

  .input {
    width: 100%;
    
    @media (min-width: 441px) {
      width: 80%;
    }
  }
}
</style>